/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ContactUs() {
    const { t } = useTranslation();


    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex items-center justify-between">
                    <div className="w-100 w-[48%] flex flex-col">
                        <div className="f-40 text-[50px] font-bold capitalize text-[#b58630]">{t("contact us")}</div>
                        <div className="font-bold text-[20px] capitalize flex items-center gap-[7px]">
                            <Link to={"/"}>{t("home")}</Link>
                            -
                            <div className="text-[#b58630]">{t("contact us")}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="f-col gap-15-res container flex flex-wrap justify-between">
                    <Link
                        to={"tel:+962791234567"}
                        className="dir-ar w-100 w-[32%] shadow-[0px_0px_10px_#00000054] rounded px-0 pb-5 flex flex-col gap-[30px] h-[250px] items-center text-center"
                    >
                        <div className="bg-[#B88831] p-[18px] w-[40%] mx-auto rounded-b flex items-center justify-center h-[120px]">
                            <img src={require("../../assets/icons/phone-contact.svg").default} alt="" />
                        </div>
                        <div>
                            <div className="text-[23px] font-bold capitalize text-[#B88831]">{t("phone")}</div>
                            <div className="font-bold">+962 79 123 4567</div>
                        </div>
                    </Link>
                    <Link
                        to={"mailto:info@omaeyewear.com"}
                        className="w-100 w-[32%] shadow-[0px_0px_10px_#00000054] rounded px-0 pb-5 flex flex-col gap-[30px] h-[250px] items-center text-center"
                    >
                        <div className="bg-[#B88831] p-[18px] w-[40%] mx-auto rounded-b flex items-center justify-center h-[120px]">
                            <img src={require("../../assets/icons/email-contact.svg").default} alt="" />
                        </div>
                        <div>
                            <div className="text-[23px] font-bold capitalize text-[#B88831]">{t("email")}</div>
                            <div className="font-bold">info@omaeyewear.com</div>
                        </div>
                    </Link>
                    <Link
                        to={""}
                        className="w-100 w-[32%] shadow-[0px_0px_10px_#00000054] rounded px-0 pb-5 flex flex-col gap-[30px] h-[250px] items-center text-center"
                    >
                        <div className="bg-[#B88831] p-[18px] w-[40%] mx-auto rounded-b flex items-center justify-center h-[120px]">
                            <img src={require("../../assets/icons/location-contact.svg").default} alt="" />
                        </div>
                        <div>
                            <div className="text-[23px] font-bold capitalize text-[#B88831]">{t("location")}</div>
                            <div className="font-bold">{t("amman jordan")}</div>
                        </div>
                    </Link>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="f-col container flex justify-between gap-[20px]">
                    <div className="w-100 w-[49%] flex flex-col gap-[20px]">
                        <div>
                            <div className="text-[25px] capitalize font-bold text-[#B88831]">{t("contact us")}</div>
                            <div className="text-[30px] font-bold capitalize">{t("do you have any question")}</div>
                        </div>
                        <div className="flex items-center gap-[7px]">
                            <Link to={""} className="bg-[#f3f3f3] p-2 rounded-lg flex items-center justify-center">
                                <img className="w-[30px] h-[30px]" src={require("../../assets/icons/facebook-contact.svg").default} alt="" />
                            </Link>
                            <Link to={""} className="bg-[#f3f3f3] p-2 rounded-lg flex items-center justify-center">
                                <img className="w-[30px] h-[30px]" src={require("../../assets/icons/instagram-contact.svg").default} alt="" />
                            </Link>
                            <Link to={""} className="bg-[#f3f3f3] p-2 rounded-lg flex items-center justify-center">
                                <img className="w-[30px] h-[30px]" src={require("../../assets/icons/linkedin-contact.svg").default} alt="" />
                            </Link>
                        </div>
                    </div>
                    <div className="w-100 w-[49%]">
                        <form>
                            <div className="flex flex-col gap-[20px]">
                                <div className="flex flex-col gap-[8px]">
                                    <div className="f-col flex gap-[10px]">
                                        <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                                            <label className="font-bold text-[#B88831] capitalize">{t("Your Name")}</label>
                                            <input
                                                className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                                                type="text"
                                                name="full name"
                                                placeholder={t("Your Name")}
                                                required
                                            />
                                        </div>
                                        <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                                            <label className="font-bold text-[#B88831] capitalize">{t("Your Phone")}</label>
                                            <input
                                                className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                                                type="text"
                                                name="phone number"
                                                placeholder={t("Your Phone")}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="f-col flex gap-[10px]">
                                        <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                                            <label className="font-bold text-[#B88831] capitalize">{t("Your Email")}</label>
                                            <input
                                                className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                                                type="email"
                                                name="email"
                                                placeholder={t("Your Email")}
                                                required
                                            />
                                        </div>
                                        <div className="flex w-100 w-[50%] flex-col gap-[4px]">
                                            <label className="font-bold text-[#B88831] capitalize">{t("subject")}</label>
                                            <input
                                                className="outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                                                type="text"
                                                name="subject"
                                                placeholder={t("subject")}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-[4px]">
                                        <label className="font-bold text-[#B88831] capitalize">{t("Your Message")}</label>
                                        <textarea
                                            className="h-[250px] max-h-[300px] outline-none border-[1px] border-[#DEDDE4] p-[10px] rounded-[4px]"
                                            name="message"
                                            placeholder={t("Your Message")}
                                        />
                                    </div>
                                </div>
                                <button className="flex items-center justify-center text-center p-[12px] bg-[#b88831] text-white font-bold text-[20px] rounded-[8px]" type="submit">
                                    <span>{t("Send")}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}